<script>
export default {
  name: "searchingImageSection"
};
</script>

<template>
  <el-row style="padding: 40px 0 40px 0; background-color: #2D2D2D">
    <el-col
      :span="24"
      style="display: flex; justify-content: center; align-items: center"
    >
      <img
        loading="lazy"
        src="../../assets/four.jpeg"
        style="width: 100%; height: 132px; position: absolute"
      />
      <span class="search-text" style="z-index: 11">"Enfield"</span>
    </el-col>
  </el-row>
</template>

<style scoped>
.search-text {
  color: #fff;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/search/searchingImageSection.vue